import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import Header from "common/js/header/header.js";
import Loader from "common/components/Loader.js";
import "common/css/master.css";
import "./periodsStyle.css";
import AddPeriodForm from "./addPeriodForm";

import { getPeriodTypeListSvc, getPeriodsListSvc, wingPeriodListSvc } from "./periodsSvc.js";
import { get } from "axios";

const PeriodsCtrl = () => {
    const [loader, setLoader] = useState("none");
    const [opacity, setOpacity] = useState(1);
    const [flgPeriodFormVisible, setFlgPeriodFormVisible] = useState(false);
    const [periodStartTm, setPeriodStartTm] = useState("");
    const [periodDuration, setPeriodDuration] = useState("");
    const [periodEndTm, setPeriodEndTm] = useState("");

    const [lstPeriod, setLstPeriod] = useState([
        // { periodId: 1, startTm: "08:00", duration: "40" },
        // { periodId: 2, startTm: "08:40", duration: "40" },
        // { periodId: 3, startTm: "09:20", duration: "40" },
        // { periodId: 4, startTm: "10:00", duration: "40" },
        // { periodId: 5, startTm: "10:40", duration: "40" },
        // { periodId: 6, startTm: "11:20", duration: "40" },
        // { periodId: 7, startTm: "12:00", duration: "40" },
        // { periodId: 8, startTm: "12:40", duration: "40" },
        // { periodId: 9, startTm: "01:20", duration: "40" },
        // { periodId: 10, startTm: "02:00", duration: "40" },
        // { periodId: 11, startTm: "02:40", duration: "40" },
        // { periodId: 12, startTm: "03:20", duration: "40" },
        // { periodId: 13, startTm: "04:00", duration: "40" },
        // { periodId: 14, startTm: "04:40", duration: "40" },
        // { periodId: 15, startTm: "05:20", duration: "40" },
        // { periodId: 16, startTm: "06:00", duration: "40" },
        // { periodId: 17, startTm: "06:40", duration: "40" },
        // { periodId: 18, startTm: "07:20", duration: "40" },
        // { periodId: 19, startTm: "08:00", duration: "40" },
        // { periodId: 20, startTm: "08:40", duration: "40" },
    ]);

    const [periodId, setPeriodId] = useState(0);

    const [lstWingPeriod, setLstWingPeriod] = useState([
        {
            wingId: 1,
            wingName: "Foundational Wing",
            lstPeriod: [
                { periodId: 1, inUse: true, periodTypeId: 1 },
                { periodId: 2, inUse: true, periodTypeId: 1 },
                { periodId: 3, inUse: true, periodTypeId: 1 },
                { periodId: 4, inUse: true, periodTypeId: 1 },
                { periodId: 5, inUse: false, periodTypeId: 2 },
                { periodId: 6, inUse: false, periodTypeId: 1 },
                { periodId: 7, inUse: false, periodTypeId: 2 },
                { periodId: 8, inUse: false, periodTypeId: 1 },
                { periodId: 9, inUse: false, periodTypeId: 2 },
                { periodId: 10, inUse: false, periodTypeId: 1 },
                { periodId: 11, inUse: false, periodTypeId: 2 },
                { periodId: 12, inUse: false, periodTypeId: 1 },
                { periodId: 13, inUse: false, periodTypeId: 2 },
                { periodId: 14, inUse: false, periodTypeId: 1 },
                { periodId: 15, inUse: false, periodTypeId: 2 },
                // { periodId: 16, inUse: false, periodTypeId: 1 },
                // { periodId: 17, inUse: false, periodTypeId: 2 },
                // { periodId: 18, inUse: false, periodTypeId: 1 },
                // { periodId: 19, inUse: false, periodTypeId: 2 },
                // { periodId: 20, inUse: false, periodTypeId: 1 },
            ],
        },
        {
            wingId: 2,
            wingName: "Preperatory Wing",
            lstPeriod: [
                { periodId: 1, inUse: true, periodTypeId: 1 },
                { periodId: 2, inUse: false, periodTypeId: 2 },
                { periodId: 3, inUse: true, periodTypeId: 1 },
                { periodId: 4, inUse: true, periodTypeId: 1 },
                { periodId: 5, inUse: false, periodTypeId: 2 },
                { periodId: 6, inUse: false, periodTypeId: 1 },
                { periodId: 7, inUse: false, periodTypeId: 2 },
                { periodId: 8, inUse: false, periodTypeId: 1 },
                { periodId: 9, inUse: false, periodTypeId: 2 },
                // { periodId: 10, inUse: false, periodTypeId: 1 },
                // { periodId: 11, inUse: false, periodTypeId: 2 },
                // { periodId: 12, inUse: false, periodTypeId: 1 },
                // { periodId: 13, inUse: false, periodTypeId: 2 },
                // { periodId: 14, inUse: false, periodTypeId: 1 },
                // { periodId: 15, inUse: false, periodTypeId: 2 },
                // { periodId: 16, inUse: false, periodTypeId: 1 },
                // { periodId: 17, inUse: false, periodTypeId: 2 },
                // { periodId: 18, inUse: false, periodTypeId: 1 },
                // { periodId: 19, inUse: false, periodTypeId: 2 },
                // { periodId: 20, inUse: false, periodTypeId: 1 },
            ],
        },
        {
            wingId: 3,
            wingName: "Middle Wing",
            lstPeriod: [
                { periodId: 1, inUse: true, periodTypeId: 2 },
                { periodId: 3, inUse: false, periodTypeId: 1 },
                { periodId: 3, inUse: true, periodTypeId: 1 },
                { periodId: 4, inUse: true, periodTypeId: 1 },
                { periodId: 5, inUse: false, periodTypeId: 2 },
                { periodId: 6, inUse: false, periodTypeId: 1 },
                { periodId: 7, inUse: false, periodTypeId: 2 },
                { periodId: 8, inUse: false, periodTypeId: 1 },
                { periodId: 9, inUse: false, periodTypeId: 2 },
                // { periodId: 10, inUse: false, periodTypeId: 1 },
                // { periodId: 11, inUse: false, periodTypeId: 2 },
                // { periodId: 12, inUse: false, periodTypeId: 1 },
                // { periodId: 13, inUse: false, periodTypeId: 2 },
                // { periodId: 14, inUse: false, periodTypeId: 1 },
                // { periodId: 15, inUse: false, periodTypeId: 2 },
                // { periodId: 16, inUse: false, periodTypeId: 1 },
                // { periodId: 17, inUse: false, periodTypeId: 2 },
                // { periodId: 18, inUse: false, periodTypeId: 1 },
                // { periodId: 19, inUse: false, periodTypeId: 2 },
                // { periodId: 20, inUse: false, periodTypeId: 1 },
            ],
        },
        {
            wingId: 4,
            wingName: "Secondary Wing",
            lstPeriod: [
                { periodId: 1, inUse: true, periodTypeId: 1 },
                { periodId: 4, inUse: false, periodTypeId: 2 },
                { periodId: 3, inUse: true, periodTypeId: 1 },
                { periodId: 4, inUse: true, periodTypeId: 1 },
                { periodId: 5, inUse: false, periodTypeId: 2 },
                { periodId: 6, inUse: false, periodTypeId: 1 },
                { periodId: 7, inUse: false, periodTypeId: 2 },
                { periodId: 8, inUse: false, periodTypeId: 1 },
                { periodId: 9, inUse: false, periodTypeId: 2 },
                // { periodId: 10, inUse: false, periodTypeId: 1 },
                // { periodId: 11, inUse: false, periodTypeId: 2 },
                // { periodId: 12, inUse: false, periodTypeId: 1 },
                // { periodId: 13, inUse: false, periodTypeId: 2 },
                // { periodId: 14, inUse: false, periodTypeId: 1 },
                // { periodId: 15, inUse: false, periodTypeId: 2 },
                // { periodId: 16, inUse: false, periodTypeId: 1 },
                // { periodId: 17, inUse: false, periodTypeId: 2 },
                // { periodId: 18, inUse: false, periodTypeId: 1 },
                // { periodId: 19, inUse: false, periodTypeId: 2 },
                // { periodId: 20, inUse: false, periodTypeId: 1 },
            ],
        },
    ]);

    const [lstPeriodType, setLstPeriodType] = useState([]);

    useEffect(() => {
        // console.log("PeriodCtrl useEffect called");
        getPeriodTypeList();
        getPeriodsList();
    }, []);

    const getPeriodTypeList = () => {
        // console.log("getFacilityList called");
        setLoader("block");
        setOpacity(0.5);
        getPeriodTypeListSvc(periodTypeListResponse);
    }


    const periodTypeListResponse = (data) => {
        // console.log("periodTypeListResponse called, data", data);
        setLoader("none");
        setOpacity(1);
        if (data.status === "Success") {
            setLstPeriodType(data.lstPeriodType);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
    }

    const getPeriodsList = () => {
        // console.log("getPeriodsList called");
        setLoader("block");
        setOpacity(0.5);
        getPeriodsListSvc(periodsListResponse); 
    }
    const periodsListResponse = (data) => {
        setLoader("none");
        setOpacity(1);
        // console.log("periodsListResponse called, data", data);
        if (data.status === "Success") {
            setLstPeriod(data.lstPeriod);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }   
    }

    const addPeriod = () => {
        // console.log("Add Period clicked");
        setPeriodId(0);
        setPeriodStartTm("");
        setPeriodDuration("");
        setPeriodEndTm("");
        setFlgPeriodFormVisible(true);
    }

    const updatePeriods = (period, label, value) => {
        // console.log("updatePeriods called, period:", period, "label:", label, "value:", value);

        const updatedWingPeriods = lstWingPeriod.map((w) => ({
            ...w,
            lstPeriod: w.lstPeriod.map((p) =>
                p.periodId === period.periodId
                    ? { ...p, [label]: value } // Dynamically update the property
                    : p
            ),
        }));
        setLstWingPeriod(updatedWingPeriods);
    };
    const updateWingPeriod = (wing, period, label, value) => {
        // console.log("updateWingPeriod called, wing ", wing, " period ", period, " label ", label, " value ", value);
        const updatedWingPeriods = lstWingPeriod.map((w) =>
            w.wingId === wing.wingId
                ? {
                    ...w,
                    lstPeriod: w.lstPeriod.map((p) =>
                        p.periodId === period.periodId
                            ? { ...p, [label]: value }
                            : p
                    ),
                }
                : w
        );
        setLstWingPeriod(updatedWingPeriods);
    }

    const savePeriod = () => {
        // console.log("Save Period clicked");
        if (periodStartTm === "") {
            toast.warn("Please enter start time");
            return;
        }
        if (periodDuration < 0 || periodDuration > 120) {
            toast.warn("Please enter valid duration");
            return;
        }
        const objPeriod = {
            periodId: periodId,
            startTm: periodStartTm,
            duration: periodDuration,
            endTm: periodEndTm,
        };
        const updatedPeriods = [...lstPeriod, objPeriod];
        setLstPeriod(updatedPeriods);
    }

    const handlePeriodStartTmChange = (value) => {
        setPeriodStartTm(value);
        if (value) {
            const [hours, minutes] = value.split(":").map(Number);
            const startTime = new Date();
            startTime.setHours(hours, minutes, 0, 0);
            const endTime = new Date(startTime.getTime() + periodDuration * 60 * 1000);
            const formattedEndTime = `${endTime.getHours().toString().padStart(2, "0")}:${endTime.getMinutes().toString().padStart(2, "0")}`;
            setPeriodEndTm(formattedEndTime);
        } else {
            setPeriodEndTm("");
        }
    }

    const handlePeriodDurationChange = (value) => {
        setPeriodDuration(value);
        if (periodStartTm) {
            const [hours, minutes] = periodStartTm.split(":").map(Number);
            const startTime = new Date();
            startTime.setHours(hours, minutes, 0, 0);
            const endTime = new Date(startTime.getTime() + value * 60 * 1000);
            const formattedEndTime = `${endTime.getHours().toString().padStart(2, "0")}:${endTime.getMinutes().toString().padStart(2, "0")}`;
            setPeriodEndTm(formattedEndTime);
        } else {
            setPeriodEndTm("");
        }
    }

    const deletePeriod = (periodId) => {
        // console.log("Delete Period called, periodId:", periodId);
        const updatedPeriods = lstPeriod.filter((period) => period.periodId !== periodId);
        setLstPeriod(updatedPeriods);
    };

    const handleSavePeriod = (newPeriod) => {
        // console.log("New Period Saved:", newPeriod);
        setLstPeriod([...lstPeriod, { ...newPeriod, periodId: lstPeriod.length + 1 }]);
        setFlgPeriodFormVisible(false);
    };

    const saveWingPeriods = () => {
        // console.log("Save Wing Periods clicked");
        // console.log("lstWingPeriod", lstWingPeriod);
    }


    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };


    return (
        <div>
            <Header />
            <ToastContainer autoClose={3000} hideProgressBar />
            <Loader loader={loader} position="fixed" />
            <div
                className="col-md-12 col-xs-12 col-centered padding-remove"
                style={{
                    cursor: loader === "none" ? "pointer" : "none",
                    pointerEvents: loader === "none" ? "auto" : "none",
                    opacity: opacity,
                }}
            >
                {/* Main Section */}
                <div className="col-lg-11 col-md-11 col-sm-11 col-xs-11 col-centered padding-remove" style={{ marginTop: "15px" }}>
                    {/* Top Row */}
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-remove" >
                        <div className="col-lg-11 col-md-11 col-sm-11 col-xs-11 padding-remove" >
                        </div>
                        <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 padding-remove" style={{ textAlign: "center" }}>
                            <span
                                id="addPeriod"
                                title="Add Period"
                                className="addIcon glyphicon glyphicon-plus-sign"
                                onClick={() => addPeriod()}
                            ></span>
                        </div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-remove"
                        style={{ marginBottom: "20px" }} >
                        <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 padding-remove" style={{ textAlign: "left" }}>
                            <h4>Master Period</h4>
                        </div>
                        <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10 padding-remove">
                            <div className="period-container">
                                {lstPeriod.map((period) => (
                                    <div key={period.periodId} className="period-box">
                                        <div className="period-start">{period.startTm}</div>
                                        <div className="period-duration">
                                            {period.duration}
                                            <span
                                                className="glyphicon glyphicon-remove delete-icon"
                                                title="Delete Period"
                                                onClick={() => deletePeriod(period.periodId)}
                                            ></span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>


                    {/* Period Type Row */}
                    <div
                        className="col-lg-12 col-md-12 col-sm-12 col-xs-12 "
                        style={{ marginBottom: "10px", border: "1px solid #ccc", borderRadius: "10px", padding: "15px", background: "#e6f7ff" }}
                    >
                        <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 padding-remove" security={{ alignItems: "center" }}>
                            <div style={{ textAlign: "left", marginBottom: "5px", }}>
                                <span className="wing-label-periods">In Use</span>
                            </div>
                        </div>
                        <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10 padding-remove">
                            <div className="period-container">
                                {lstPeriod.map((period) => (
                                    <div key={period.periodId} className="period-box text-left">
                                        <div className="in-use ">
                                            <input
                                                type="checkbox"
                                                checked={period.inUse}
                                                onChange={(e) => updatePeriods(period, "inUse", e.target.checked)}
                                            />
                                        </div>
                                        <div className="period-type">
                                            <select
                                                // className="form-control"
                                                style={{ width: "100%", marginBottom: "5px" }}
                                                value={period.periodTypeId}
                                                onChange={(e) => updatePeriods(period, "periodTypeId", e.target.value)}
                                            >
                                                <option value={0}>Period Type</option>
                                                {/* <option value={0}>--None--</option> */}
                                                {lstPeriodType.map((type, index) => (
                                                    <option key={type.periodTypeId} value={type.periodTypeId}>{type.periodType}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                ))}
                            </div >
                        </div >
                        <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 padding-remove" style={{ textAlign: "center" }}>
                        </div >
                    </div >

                    {/* Wing Period Rows */}
                    {lstWingPeriod.map((wing) => (
                        <div
                            key={wing.wingId}
                            className="col-lg-12 col-md-12 col-sm-12 col-xs-12 "
                            style={{ marginBottom: "10px", border: "1px solid #ccc", borderRadius: "10px", padding: "10px" }}
                        >
                            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 padding-remove">
                                <div style={{ textAlign: "left", }}>
                                    <span className="wing-label-periods">{wing.wingName}</span>
                                </div>
                            </div>
                            <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10 padding-remove">
                                <div className="period-container">
                                    {wing.lstPeriod.map((period) => (
                                        <div key={period.periodId} className="period-box text-left">
                                            <div className="in-use">
                                                <input
                                                    type="checkbox"
                                                    checked={period.inUse}
                                                    onChange={(e) => updateWingPeriod(wing, period, "inUse", e.target.checked)}
                                                />
                                            </div>
                                            <div className="period-type">
                                                <select
                                                    // className="form-control"
                                                    style={{ width: "100%", marginBottom: "5px" }}
                                                    value={period.periodTypeId}
                                                    onChange={(e) => updateWingPeriod(wing, period, "periodTypeId", e.target.value)}
                                                >
                                                    <option value={0}>Period Type</option>
                                                    {/* <option value={0}>--None--</option> */}
                                                    {lstPeriodType.map((type, index) => (
                                                        <option key={type.periodTypeId} value={type.periodTypeId}>{type.periodType}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    ))}
                                </div >
                            </div >
                            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 padding-remove" style={{ textAlign: "center" }}>
                            </div >
                        </div >
                    ))}
                    <div className="col-sm-1 col-md-1 padding-remove pull-right">
                        <button type="button" className="btn btn-info" onClick={saveWingPeriods}>
                            Save
                        </button>
                    </div>
                </div >
            </div >
            {
                flgPeriodFormVisible && (
                    <AddPeriodForm
                        onSave={handleSavePeriod}
                        onClose={() => setFlgPeriodFormVisible(false)}
                    />
                )
            }
        </div >
    );
};

export default PeriodsCtrl;